import { render } from "./board.vue?vue&type=template&id=739b1ce2&scoped=true&ts=true"
import script from "./board.vue?vue&type=script&lang=ts"
export * from "./board.vue?vue&type=script&lang=ts"

import "./board.vue?vue&type=style&index=0&id=739b1ce2&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739b1ce2"]])

export default __exports__